import { render, staticRenderFns } from "./GroupDashboardYearlyPiePerMonth.vue?vue&type=template&id=3c5dce65&"
import script from "./GroupDashboardYearlyPiePerMonth.vue?vue&type=script&lang=js&"
export * from "./GroupDashboardYearlyPiePerMonth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports